module.exports = __webpack_public_path__ + "img/icn_comment.69ffbb58.svg";